import { HStack, Icon, Pressable } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { theme } from 'styles/configure-theme';

import { ContentHeader } from './styled';

type PaymentMethodSelectorHeaderProps = {
  isReloadDrawer?: boolean;
  noPaymentMethodsAvailable?: boolean;
  onClose?: () => void;
};
export function PaymentMethodSelectorHeader({
  onClose,
  isReloadDrawer,
  noPaymentMethodsAvailable,
}: PaymentMethodSelectorHeaderProps) {
  const { formatMessage } = useIntl();
  const headerTitle = noPaymentMethodsAvailable
    ? isReloadDrawer
      ? formatMessage({ id: 'loadWith' })
      : formatMessage({ id: 'addPaymentMethodOrReload' })
    : formatMessage({ id: 'selectPaymentMethodDrawer' });

  return (
    <HStack width="full" justifyContent="center" alignContent="center">
      <ContentHeader width="95%">{headerTitle}</ContentHeader>
      <Pressable
        accessible={true}
        accessibilityLabel={formatMessage({ id: 'back' })}
        accessibilityRole="button"
        onPress={onClose}
      >
        <Icon
          variant={'cancel'}
          color={theme.token('icon-default')}
          title={formatMessage({ id: 'back' })}
        />
      </Pressable>
    </HStack>
  );
}
